import * as _ from "lodash";
import { call, put, select } from "redux-saga/effects";

import actions from "@/actions";
import { Api, ConfigurationManager } from "@/utils";

import handleDuplicateFlags from "./handle-duplicate-flags/handle-duplicate-flags";

/**
 * Checks floorspace catalogs for a VLC ID and auto-assigns BLE beacon data when possible.
 *
 * @param root0 - The action.
 * @param root0.payload - The VLC ID and catalog check parameters.
 * @yields Calls the floorspace catalog API and dispatches beacon assignments.
 */
function* checkFloorspaceCatalogs({ payload }) {
    try {
        const { lights, positioningTypes } = yield select(({ map }) => ({
            lights: _.cloneDeep(map.values.global.present.lights),
            positioningTypes:
                map.general.settings.fixtureDetails.positioningType,
        }));
        const light = lights[payload.uniqueId];
        if (payload.vlc === "" || payload.vlc === light.id) return;
        light.id = payload.vlc;
        if (positioningTypes !== "VLC") {
            yield put(
                actions.window.openLoading(
                    "Hold on! We're checking the floorspace catalog...",
                ),
            );
            const { floorSpaceId } = ConfigurationManager.values;
            const url = `v1/floor-space-catalogs/floor-space-id/${floorSpaceId}/vlc-id/${payload.vlc}`;
            const { result: catalogs } = yield call(Api.get, url);
            if (catalogs.length >= 1) {
                const beacons = _.filter(
                    catalogs,
                    (catalog) => catalog.beaconID !== null,
                );
                if (beacons.length <= 1) {
                    light.bleId =
                        beacons[0] && beacons[0].beaconID
                            ? beacons[0].beaconID
                            : "0";
                    light.bleUUID =
                        beacons[0] && beacons[0].beaconUUID
                            ? beacons[0].beaconUUID
                            : null;
                    yield call(handleDuplicateFlags, lights);
                } else {
                    _.each(beacons, (beacon) => {
                        beacon.vlcId = light.id;
                    });
                    yield put(
                        actions.map.general.setFloorspaceCatalogs(beacons),
                    );
                }
            } else {
                yield put(actions.map.values.global.updateLights(lights));
            }
        } else {
            yield call(handleDuplicateFlags, lights);
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on checking floorspace catalog:", err);
    } finally {
        yield put(actions.window.closeLoading());
    }
}

export default checkFloorspaceCatalogs;
